import type { GalleryItem } from "@/types"

export const galleryItems: GalleryItem[] = [
    {
        id: "gal-sg-01",
        image: require("@/assets/imgs/gallery/CG/cg-sargon-2.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-sargon-2.png"),
        title: "map.gallery.sg01",
        unlocked: false,
        regionId: "sargon",
    },
    {
        id: "gal-sg-02",
        image: require("@/assets/imgs/gallery/CG/cg-sargon-3.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-sargon-3.png"),
        title: "map.gallery.sg02",
        unlocked: false,
        regionId: "sargon",
    },
    {
        id: "gal-sg-03",
        image: require("@/assets/imgs/gallery/CG/cg-sargon-4.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-sargon-4.png"),
        title: "map.gallery.sg03",
        unlocked: false,
        regionId: "sargon",
    },
    {
        id: "gal-sm-01",
        image: require("@/assets/imgs/gallery/CG/cg-sami-3.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-sami-3.png"),
        title: "map.gallery.sm01",
        unlocked: false,
        regionId: "sami",
    },
    {
        id: "gal-sm-02",
        image: require("@/assets/imgs/gallery/CG/cg-sami-4.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-sami-4.png"),
        title: "map.gallery.sm02",
        unlocked: false,
        regionId: "sami",
    },
    {
        id: "gal-sm-03",
        image: require("@/assets/imgs/gallery/CG/cg-sami-5.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-sami-5.png"),
        title: "map.gallery.sm03",
        unlocked: false,
        regionId: "sami",
    },
    {
        id: "gal-us-01",
        image: require("@/assets/imgs/gallery/CG/cg-ursus-3.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-ursus-3.png"),
        title: "map.gallery.us01",
        unlocked: false,
        regionId: "ursus",
    },
    {
        id: "gal-us-02",
        image: require("@/assets/imgs/gallery/CG/cg-ursus-4.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-ursus-4.png"),
        title: "map.gallery.us02",
        unlocked: false,
        regionId: "ursus",
    },
    {
        id: "gal-us-03",
        image: require("@/assets/imgs/gallery/CG/cg-ursus-5.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-ursus-5.png"),
        title: "map.gallery.us03",
        unlocked: false,
        regionId: "ursus",
    },
    {
        id: "gal-vc-01",
        image: require("@/assets/imgs/gallery/CG/cg-victoria-3.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-victoria-3.png"),
        title: "map.gallery.vc01",
        unlocked: false,
        regionId: "victoria",
    },
    {
        id: "gal-vc-02",
        image: require("@/assets/imgs/gallery/CG/cg-victoria-4.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-victoria-4.png"),
        title: "map.gallery.vc02",
        unlocked: false,
        regionId: "victoria",
    },
    {
        id: "gal-vc-03",
        image: require("@/assets/imgs/gallery/CG/cg-victoria-5.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-victoria-5.png"),
        title: "map.gallery.vc03",
        unlocked: false,
        regionId: "victoria",
    },
    {
        id: "gal-lt-01",
        image: require("@/assets/imgs/gallery/CG/cg-leithania-3.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-leithania-3.png"),
        title: "map.gallery.lt01",
        unlocked: false,
        regionId: "leithanien",
    },
    {
        id: "gal-lt-02",
        image: require("@/assets/imgs/gallery/CG/cg-leithania-4.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-leithania-4.png"),
        title: "map.gallery.lt02",
        unlocked: false,
        regionId: "leithanien",
    },
    {
        id: "gal-lt-03",
        image: require("@/assets/imgs/gallery/CG/cg-leithania-5.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-leithania-5.png"),
        title: "map.gallery.lt03",
        unlocked: false,
        regionId: "leithanien",
    },
    {
        id: "gal-kz-01",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-3.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-kazdel-3.png"),
        title: "map.gallery.kz01",
        unlocked: false,
        regionId: "kazdel",
    },
    {
        id: "gal-kz-02",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-4.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-kazdel-4.png"),
        title: "map.gallery.kz02",
        unlocked: false,
        regionId: "kazdel",
    },
    {
        id: "gal-kz-03",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-5.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-kazdel-5.png"),
        title: "map.gallery.kz03",
        unlocked: false,
        regionId: "kazdel",
    },
    {
        id: "gal-kz-04",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-6.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-kazdel-6.png"),
        title: "map.gallery.kz04",
        unlocked: false,
        regionId: "kazdel",
    },
    {
        id: "gal-ri-01",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-3-1.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-3-1.png"),
        title: "map.gallery.ri01",
        unlocked: false,
        regionId: "babel_rhodes",
    },
    {
        id: "gal-ri-02",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-3-2.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-3-2.png"),
        title: "map.gallery.ri02",
        unlocked: false,
        regionId: "babel_rhodes",
    },
    {
        id: "gal-ri-03",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-4-1.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-4-1.png"),
        title: "map.gallery.ri03",
        unlocked: false,
        regionId: "babel_rhodes",
    },
    {
        id: "gal-ri-04",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-4-2.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-4-2.png"),
        title: "map.gallery.ri04",
        unlocked: false,
        regionId: "babel_rhodes",
    },
    {
        id: "gal-ri-05",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-5-1.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-5-1.png"),
        title: "map.gallery.ri05",
        unlocked: false,
        regionId: "babel_rhodes",
    },
    {
        id: "gal-ri-06",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-5-2.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-5-2.png"),
        title: "map.gallery.ri06",
        unlocked: false,
        regionId: "babel_rhodes",
    },
    {
        id: "gal-ri-07",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-6-1.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-6-1.png"),
        title: "map.gallery.ri07",
        unlocked: false,
        regionId: "babel_rhodes",
    },
    {
        id: "gal-ri-08",
        image: require("@/assets/imgs/gallery/CG/cg-rhodes-6-2.png"),
        thumbnail: require("@/assets/imgs/gallery/CG/cg-rhodes-6-2.png"),
        title: "map.gallery.ri08",
        unlocked: false,
        regionId: "babel_rhodes",
    },
]
